// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"75dea9639c6e2c688d3b","214":"bd8aac0fd490ae6f1c76","862":"259a67e91e21b1a0f8d0","958":"53072e1b6ef8a0c1bc50"}[chunkId] + ".chunk.js";
};